export const DateAndTime_UPDATE_REQUEST = "DateAndTime_UPDATE_REQUEST";
export const DateAndTime_UPDATE_SUCCESS = "DateAndTime_UPDATE_SUCCESS";
export const DateAndTime_UPDATE_FAILURE = "DateAndTime_UPDATE_FAILURE";
export const DateAndTime_UPDATE_RESET = "DateAndTime_UPDATE_RESET";


export const UNREAD_RECORD_UPLOAD_REQUEST = "UNREAD_RECORD_UPLOAD_REQUEST";
export const UNREAD_RECORD_UPLOAD_SUCCESS = "UNREAD_RECORD_UPLOAD_SUCCESS";
export const UNREAD_RECORD_UPLOAD_FAILURE = "UNREAD_RECORD_UPLOAD_FAILURE";